import React from "react";

import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
  useBoolean,
} from "@chakra-ui/react";

import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";

type PasswordInputProps = InputProps;

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ size, ...inputProps }, ref) => {
    const [show, { toggle }] = useBoolean(false);

    return (
      <InputGroup size={size}>
        <Input {...inputProps} ref={ref} type={show ? "text" : "password"} />
        <InputRightElement>
          <IconButton
            variant="ghost"
            onClick={toggle}
            aria-label={show ? "Hide password" : "Show password"}
            icon={show ? <Icon as={EyeIcon} /> : <Icon as={EyeOffIcon} />}
          ></IconButton>
        </InputRightElement>
      </InputGroup>
    );
  }
);

export default React.memo(PasswordInput);
